export default __webpack_public_path__ + "static/media/press-door-bags.e36ec481.png";